import axios from 'axios'
import {createI18n} from 'vue-i18n'

export const i18n = createI18n({
    legacy: false,
    locale: window.app.orderhistory.siteLanguageHrefLang,
})

// export const i18n = new VueI18n({
//     locale: window.app.orderhistory.siteLanguageHrefLang
// })

export function loadLanguageAsync() {
  const locale = window.app.orderhistory.siteLanguageHrefLang
  const url = window.app.orderhistory.translationsAssetsPath + `/${locale}.json`

  return axios.get(url).then(response => {
        i18n.global.setLocaleMessage(window.app.orderhistory.siteLanguageHrefLang, response.data)
      }
  )
}

